const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

/** « mardi 8 septembre 2026 » */
export function dateLongue(iso: string): string {
  const d = new Date(iso)
  return `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]} ${d.getFullYear()}`
}

/** « 08-09 14:22 » — compact, pour la vignette d'une photo. */
export function horodatageCourt(iso: string): string {
  const d = new Date(iso)
  const n = (x: number) => String(x).padStart(2, '0')
  return `${n(d.getDate())}-${n(d.getMonth() + 1)} ${n(d.getHours())}:${n(d.getMinutes())}`
}

/** Clé de regroupement par jour, dans le fuseau local. */
export function cleJour(iso: string): string {
  const d = new Date(iso)
  const n = (x: number) => String(x).padStart(2, '0')
  return `${d.getFullYear()}-${n(d.getMonth() + 1)}-${n(d.getDate())}`
}

export function poids(octets: number | null | undefined): string {
  if (!octets) return '—'
  if (octets < 1024 * 1024) return `${Math.round(octets / 1024)} Ko`
  return `${(octets / (1024 * 1024)).toFixed(octets < 10 * 1024 * 1024 ? 1 : 0)} Mo`.replace('.', ',')
}

export const LIBELLE_SOURCE: Record<string, string> = {
  appareil: "Prise dans l'app",
  televersee: 'Téléversée'
}

export const LIBELLE_ORIGINE: Record<string, string> = {
  appareil: 'heure du déclenchement',
  exif: 'date du fichier',
  manuelle: 'date saisie',
  inconnue: 'date inconnue'
}

/** « 12 novembre 2026 » à partir d'une date AAAA-MM-JJ (sans décalage de fuseau). */
export function jourCalendrier(ymd: string): string {
  const [a, m, j] = ymd.split('-').map(Number)
  if (!a || !m || !j) return ymd
  return `${j} ${MOIS[m - 1]} ${a}`
}
